import React, { useState } from "react";
import CommonImageSlider from "./comandata";
import { studentsRanks } from "./data";
import CommonImageSliderRanks from "./CommonsliderRanks";

const Contact = () => {
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  function generateCaptcha() {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    return Array.from({ length: 5 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
  }

  const refreshCaptcha = () => {
    setCaptcha(generateCaptcha());
    setCaptchaInput("");
    setCaptchaError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (captchaInput !== captcha) {
      setCaptchaError("Invalid CAPTCHA. Please try again.");
      return;
    }
    setCaptchaError("");
    alert("Form submitted successfully!");
  };

  const branches = [
    {
      title: "KPHB Admissions Office",
      address: `Plat No 369, Road No 8, Beside Lotus Hospital Lane,
Phase 1, Kukatpally Housing Board Colony,
Kukatpally, Hyderabad, Telangana 500072`,
      phone: "+91 9959721353",
      email: "contact@rankridgehyderabad.com",
    },
  ];

  return (
    <div className="bg-neutral-50 text-neutral-900 py-1 px-4  sm:px-6 lg:px-16 xl:px-24">
            <h1 className="text-3xl md:text-4xl font-extrabold text-center text-[#20b2aa] mb-10">
        We’re Happy to Help – Contact Us for Details
      </h1>

      <div className=" bg-neutral-50 text-neutral-900 grid gap-6 lg:grid-cols-3">
        {/* Contact Info */}
        <div className="space-y-6">
          {branches.map((branch, index) => (
            <div key={index} className="bg-neutral-50 text-neutral-900 p-6 rounded-lg shadow-md space-y-4">
              <h3 className="text-xl font-bold text-[#390303]">{branch.title}</h3>
              <div className="flex items-start gap-4">
                <div className="bg-gray-200 p-3 rounded-full">📍</div>
                <p className="text-sm text-gray-600 whitespace-pre-line">{branch.address}</p>
              </div>
              <hr />
              <div className="flex items-start gap-4">
                <div className="bg-gray-200 p-3 rounded-full">📞</div>
                <p className="text-sm text-gray-600">{branch.phone}</p>
              </div>
              <hr />
              <div className="flex items-start gap-4">
                <div className="bg-gray-200 p-3 rounded-full">💬</div>
                <p className="text-sm text-gray-600">{branch.email}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Map */}
        <div className="rounded-lg overflow-hidden shadow-md h-full">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.3643546417666!2d78.39237617493723!3d17.49011218341474!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9142171bf8fd%3A0x25cda1199abf1471!2sRANKRIDGE%20-%20Best%20INTER%20College%20%26%20IITJEE%20%7C%20NEET%20%7C%20EAMCET%20Coaching.%20Top%20Junior%20College%20for%20MPC%20%7C%20BIPC%20in%20Hyderabad%20Telangana!5e0!3m2!1sen!2sin!4v1752565372468!5m2!1sen!2sin"
               width="600" 
               height="450" 
                allowfullscreen=""
               loading="lazy"
               referrerpolicy="no-referrer-when-downgrade">
               </iframe>
        </div>

        {/* Contact Form with CAPTCHA */}
        <form
          onSubmit={handleSubmit}
          className="bg-white p-6 rounded-lg shadow-md space-y-4 overflow-y-auto max-h-[600px]"
        >
          <div>
            <label className="block text-sm font-medium text-gray-700">Name *</label>
            <input type="text" placeholder="Enter Student Name" className="w-full border rounded px-3 py-2 mt-1" required />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Mobile Number *</label>
            <div className="flex">
              <select className="border px-2 py-2 rounded-l bg-gray-100">
                <option value="+91">+91</option>
              </select>
              <input type="text" placeholder="Enter WhatsApp Number" className="w-full border rounded-r px-3 py-2" required />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Gender *</label>
            <select className="w-full border rounded px-3 py-2 mt-1" required>
              <option>Select Gender</option>
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Parent’s Name *</label>
            <input type="text" placeholder="Enter Parent Name" className="w-full border rounded px-3 py-2 mt-1" required />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Parent Mobile No *</label>
            <input type="text" placeholder="Enter Parent Mobile Number" className="w-full border rounded px-3 py-2 mt-1" required />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">State *</label>
            <select className="w-full border rounded px-3 py-2 mt-1" required>
              <option>Select State</option>
              <option>Telangana</option>
              <option>Andhra Pradesh</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">City *</label>
            <select className="w-full border rounded px-3 py-2 mt-1" required>
              <option>Select City</option>
              <option>Hyderabad</option>
              <option>Vijayawada</option>
              <option>Warangal</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Admission Type *</label>
            <select className="w-full border rounded px-3 py-2 mt-1" required>
              <option>Select Admission Type</option>
              <option>Intermediate</option>
              <option>Long Term</option>
              <option>School</option>
            </select>
          </div>

          {/* CAPTCHA */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">CAPTCHA *</label>
            <div className="flex items-center gap-2">
              <div className="px-4 py-2 bg-gray-200 font-mono text-lg rounded select-none">{captcha}</div>
              <span
                onClick={refreshCaptcha}
                className="cursor-pointer text-xl hover:rotate-90 transition-transform duration-300"
                title="Refresh CAPTCHA"
              >
                🔄
              </span>
            </div>
            <input
              type="text"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              placeholder="Enter CAPTCHA"
              className="w-full border rounded px-3 py-2 mt-2"
              required/>
            {captchaError && <p className="text-red-600 text-sm mt-1">{captchaError}</p>}
          </div>

          <button type="submit" className="w-full bg-[#20b2aa] hover:bg-[#20b2aa] text-white py-2 rounded mt-3">
            Submit
          </button>
        </form>
      </div>
             <CommonImageSliderRanks className="h-10" images={studentsRanks} />

    </div>
  );
};

export default Contact;
